module.exports = __webpack_public_path__ + "img/caret-down.b1a7c6c8.svg";